<template>
    <employment-doc-view
        v-bind="{
            value: fields,
            pages,
            mode,
        }"
        @input="emit"
    />
</template>

<script>
import { EMPLOYMENT_FIELD_SIDES, initEmploymentContract } from "@/assets/variables";
import EmploymentDocView from "@/components/dashboard/common/employment/doc/employment-doc-view.vue";

export default {
    components: {
        EmploymentDocView,
    },
    props: {
        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "form" },

        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentForm>} */
        value: { type: Object, default: initEmploymentContract },
    },
    data: () => ({
        form: initEmploymentContract(),
    }),
    computed: {
        fields() {
            return [...(this.form?.form?.fields || []).filter(({ side }) => side == EMPLOYMENT_FIELD_SIDES.DOCUMENT.value), ...this.form.fields_employee];
        },
        pages() {
            return this.form?.form?.pages;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentContract(this.value);
        },

        emit(fields) {
            let fields_employee = fields.filter(({ side }) => side == EMPLOYMENT_FIELD_SIDES.EMPLOYEE.value);
            this.form = initEmploymentContract({ ...this.form, fields_employee });
            this.$emit("input", this.form);
        },
    },
};
</script>

<style></style>
